import { useMemo } from 'react';
import { useSizeAndWidthContext } from '../context';
import { hasMatchingWidthVariant, isValueDisplayed } from '../utils';

export function useFilteredSizes() {
  const { selectedWidth, isSubdomainOutlet, uniqueSizes, variants } = useSizeAndWidthContext();
  return useMemo(() => {
    const sizesWithMatchingWidthVariants = uniqueSizes.filter(
      (productSize) => productSize && hasMatchingWidthVariant(productSize, selectedWidth, variants),
    );
    return sizesWithMatchingWidthVariants.filter((size) =>
      isValueDisplayed(size, selectedWidth, variants, isSubdomainOutlet),
    );
  }, [isSubdomainOutlet, selectedWidth, uniqueSizes, variants]);
}
